module.exports = __webpack_public_path__ + "static/nota-ahazou-05c11926c3d8610eb529bcb88614d84a.svg";